import { useState, useCallback, useEffect } from 'react';
import groupServices from 'services/group.services';

export default function useGetGroupPlatformAgreementType() {
  const [loading, setLoading] = useState(false);
  const [listAgreementTypes, setListAgreementTypes] = useState([]);

  const getAgreementTypes = useCallback(async () => {
    try {
      setLoading(true);
      const data = await groupServices.listPlatformAgreementType();
      setListAgreementTypes(data.items);
    } catch (err) {
      console.error(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getAgreementTypes();
  }, []);

  return {
    loading,
    listAgreementTypes,
    getAgreementTypes
  };
}
